import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { Navigate, useParams } from "react-router";

import GetGeometryTypeBimClass from "./GetGeometryTypeBimClass.graphql";
import { TAXONOMY_BASE } from "../../../../constants";

/** Was a data-router `loader`; see BimClass/RedirectToRevision. */
export default function RedirectToGeometryType() {
    const { geometryTypeID } = useParams();

    const getGeometryTypeBimClass = useQuery(
        gql(GetGeometryTypeBimClass),
        {
            variables: {
                id: geometryTypeID,
            },
        },
    );

    if (getGeometryTypeBimClass.loading) return "loading";
    if (getGeometryTypeBimClass.error) return "error";

    const geometryType = getGeometryTypeBimClass.data?.geometryType;

    if (!geometryType) return <Navigate replace to={ TAXONOMY_BASE } />;

    return (
        <Navigate
            replace
            to={ `${ TAXONOMY_BASE }/BimClasses/${ geometryType.bimClass.id }/GeometryTypes/${ geometryTypeID }` }
        />
    );
}
